import { IS_OTP_GRAPHQL_PREVIEW_AVAILABLE } from "@/config/guards";
import { env } from "@/env.setup"

/**
 * Fetches the current build version string (e.g. "001") for the given status.
 * Returns null if no build is found or the request fails.
 */
export async function getCurrentBuildVersion(): Promise<string | null> {
  try {
    const status = IS_OTP_GRAPHQL_PREVIEW_AVAILABLE ? "InPreview" : "Live";
    const res = await fetch(`${env.VITE_API_URL}/api/Build/ByStatus/${status}`)

    if (!res.ok) {
      return null
    }

    const builds = await res.json()

    if (!Array.isArray(builds) || builds.length === 0) {
      return null
    }

    return builds[0].path as string
  } catch {
    return null
  }
}
